module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-fade-in-linear",
      "mode": "out-in"
    }
  }, [_c('div', [_c('section', {
    staticClass: "section section-white category-view-warp",
    style: ('height: ' + (_vm.wheight - 160) + 'px;')
  }, [_c('div', {
    staticClass: "category-type-view"
  }, [_c('div', {
    staticClass: "category-type-scroll"
  }, [_c('div', {
    staticClass: "layout-miniature",
    class: {
      active: _vm.form.name === 'base'
    },
    on: {
      "click": function($event) {
        return _vm.switchType('base')
      }
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout-left"
  }, [_c('div', {
    staticClass: "layout-item",
    class: {
      active: _vm.form.name === 'base'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layout-item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-right"
  }, [_c('div', {
    staticClass: "layout-group"
  }, [_c('div', {
    staticClass: "layout-banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "layout-item-list"
  }, [_c('div', {
    staticClass: "layout-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-name"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "category-view"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "layout-view"
  }, [(_vm.series.length > 0) ? _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.editableSeries),
      callback: function($$v) {
        _vm.editableSeries = $$v
      },
      expression: "editableSeries"
    }
  }, _vm._l((_vm.series), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.form.name == 'base' && _vm.editableData.length > 0) ? _c('div', [_c('div', {
    staticClass: "layout-view"
  }, [_c('div', {
    staticClass: "parent-view"
  }, _vm._l((_vm.editableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "parent-item",
      class: {
        active: index === _vm.currentFidx
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(index)
        }
      }
    }, [(item.hot) ? _c('span', {
      staticClass: "hot-tag"
    }) : _vm._e(), _vm._v(_vm._s(item.name ? item.name : '分类') + "\n                  ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "child-layout-view"
  }, [_c('div', {
    staticClass: "layout-group"
  }, [_c('img', {
    staticClass: "parent-img",
    attrs: {
      "src": _vm.editableData[_vm.currentFidx].img ? _vm.editableData[_vm.currentFidx].img : 'https://fakeimg.pl/250x100/EFEFEF/CCC/',
      "alt": ""
    }
  }), _vm._v(" "), _vm._l((_vm.editableData[_vm.currentFidx].children), function(sitem, sidx) {
    return _c('div', {
      key: sidx,
      staticClass: "child"
    }, [(sitem.name) ? _c('div', {
      staticClass: "second-title"
    }, [_vm._v(_vm._s(sitem.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "child-view"
    }, _vm._l((sitem.children), function(litem, lidx) {
      return _c('div', {
        key: lidx,
        staticClass: "child-item"
      }, [_c('img', {
        staticClass: "child-img",
        attrs: {
          "src": litem.img ? litem.img : 'https://fakeimg.pl/50x50/EFEFEF/CCC/',
          "alt": ""
        }
      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(litem.name ? litem.name : '子分类'))])])
    }), 0)])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.form.name == 'fresh' && _vm.editableData.length > 0) ? _c('div', [_c('div', {
    staticClass: "layout-view"
  }, [_c('div', {
    staticClass: "parent-view"
  }, _vm._l((_vm.editableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "parent-item",
      class: {
        active: index === _vm.currentFidx
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(index)
        }
      }
    }, [_vm._v(_vm._s(item.name ? item.name : '分类'))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "child-layout-view"
  }, [_c('div', {
    staticClass: "layout-group"
  }, [_c('img', {
    staticClass: "parent-img",
    attrs: {
      "src": _vm.editableData[_vm.currentFidx].img ? _vm.editableData[_vm.currentFidx].img : 'https://fakeimg.pl/250x100/EFEFEF/CCC/',
      "alt": ""
    }
  }), _vm._v(" "), _vm._l((3), function(item) {
    return _c('div', {
      staticClass: "child-goods-view"
    }, [_c('div', {
      staticClass: "child-item"
    }, [_c('img', {
      staticClass: "item-img",
      attrs: {
        "src": "https://fakeimg.pl/70x70/EFEFEF/CCC/",
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-caption"
    }, [_c('div', [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("当前类目商品标题")]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_vm._v("当前类目商品描述")])]), _vm._v(" "), _c('div', {
      staticClass: "item-icon"
    }, [_c('div', {
      staticClass: "iconfont icon-cart-plus"
    })])])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.form.name == 'beauty' && _vm.editableData.length > 0) ? _c('div', [_c('div', {
    staticClass: "layout-view layout-second"
  }, [_c('div', {
    staticClass: "child-layout-view"
  }, _vm._l((_vm.editableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "layout-group",
      class: {
        active: index === _vm.currentFidx
      }
    }, [_c('img', {
      staticClass: "parent-img",
      attrs: {
        "src": item.img ? item.img : 'https://fakeimg.pl/320x120/EFEFEF/CCC/',
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(index)
        }
      }
    }), _vm._v(" "), _vm._l((item.children), function(sitem, sidx) {
      return _c('div', {
        key: sidx,
        staticClass: "child"
      }, [(sitem.name) ? _c('div', {
        staticClass: "second-title"
      }, [_vm._v(_vm._s(sitem.name))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "child-view"
      }, _vm._l((sitem.children), function(litem, lidx) {
        return _c('div', {
          key: lidx,
          staticClass: "child-item"
        }, [_c('img', {
          staticClass: "child-img",
          attrs: {
            "src": litem.img ? litem.img : 'https://fakeimg.pl/70x70/EFEFEF/CCC/',
            "alt": ""
          }
        }), _vm._v(" "), _c('div', [_vm._v(_vm._s(litem.name ? litem.name : '子分类'))])])
      }), 0)])
    })], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.editableData.length) ? _c('div', {
    staticClass: "no-category-placeholder"
  }, [_c('div', {
    staticClass: "iconfont icon-th-list"
  }), _vm._v(" "), _c('div', [_vm._v("请添加分类")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "category-setting-view"
  }, [_c('div', {
    staticClass: "category-form"
  }, [_c('div', {
    staticClass: "content-bottom-padded clearfix"
  }, [_c('div', {
    staticClass: "series"
  }, [(_vm.series.length > 0) ? _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.editableSeries),
      callback: function($$v) {
        _vm.editableSeries = $$v
      },
      expression: "editableSeries"
    }
  }, _vm._l((_vm.series), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    }, [(_vm.editableSeries === item.name) ? _c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('el-input', {
      staticClass: "series-name-input",
      attrs: {
        "size": "mini"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-times",
      on: {
        "click": function($event) {
          return _vm.removeTab(item.name)
        }
      }
    })], 1) : _vm._e()])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "160"
    },
    model: {
      value: (_vm.seriesVisible),
      callback: function($$v) {
        _vm.seriesVisible = $$v
      },
      expression: "seriesVisible"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "size": "small",
      "placeholder": "请输入系列名称"
    },
    model: {
      value: (_vm.seriesTitle),
      callback: function($$v) {
        _vm.seriesTitle = $$v
      },
      expression: "seriesTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "text"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addSeries
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "add-btn iconfont icon-plus-circle",
    attrs: {
      "slot": "reference",
      "type": "text"
    },
    slot: "reference"
  }, [_vm._v(" 添加系列")])], 1)], 1)]), _vm._v(" "), _c('draggable', _vm._b({
    model: {
      value: (_vm.editableData),
      callback: function($$v) {
        _vm.editableData = $$v
      },
      expression: "editableData"
    }
  }, 'draggable', _vm.dragParentOptions, false), _vm._l((_vm.editableData), function(item, fidx) {
    return _c('div', {
      key: item._uid || fidx,
      staticClass: "form-parent"
    }, [_c('div', {
      staticClass: "form-item"
    }, [_c('div', {
      staticClass: "setting-img",
      on: {
        "click": function($event) {
          return _vm.showImgs(fidx)
        }
      }
    }, [(item.img) ? _c('img', {
      attrs: {
        "src": item.img ? item.img : 'https://fakeimg.pl/50x50',
        "alt": ""
      }
    }) : _c('div', {
      staticClass: "iconfont icon-images"
    })]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "名称"
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }), _vm._v(" "), (_vm.form.name === 'fresh') ? _c('div', {
      staticClass: "bind-btn iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.showCategory(fidx)
        }
      }
    }, [_vm._v(" " + _vm._s(item.category_name ? item.category_name : '绑定分类'))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bind-btn iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.openPageDialog(fidx)
        }
      }
    }, [_vm._v(" " + _vm._s(item.page_name ? item.page_name : '绑定自定义页面'))]), _vm._v(" "), _c('el-checkbox', {
      model: {
        value: (item.hot),
        callback: function($$v) {
          _vm.$set(item, "hot", $$v)
        },
        expression: "item.hot"
      }
    }, [_vm._v("热推")]), _vm._v(" "), _c('div', {
      staticClass: "control-bar move iconfont icon-stream"
    }), _vm._v(" "), _c('div', {
      staticClass: "control-bar remove iconfont icon-trash",
      on: {
        "click": function($event) {
          return _vm.remove(fidx)
        }
      }
    })], 1), _vm._v(" "), (_vm.form.name !== 'fresh') ? _c('div', {
      staticClass: "form-child"
    }, [_c('draggable', _vm._b({
      model: {
        value: (item.children),
        callback: function($$v) {
          _vm.$set(item, "children", $$v)
        },
        expression: "item.children"
      }
    }, 'draggable', _vm.dragSecondOptions, false), _vm._l((item.children), function(sitem, sidx) {
      return _c('div', {
        key: sitem._uid || sidx,
        staticClass: "form-second"
      }, [_c('div', {
        staticClass: "form-item"
      }, [_c('div', {
        staticClass: "setting-img",
        on: {
          "click": function($event) {
            return _vm.showImgs(fidx, sidx)
          }
        }
      }, [(sitem.img) ? _c('img', {
        attrs: {
          "src": sitem.img ? sitem.img : 'https://fakeimg.pl/50x50',
          "alt": ""
        }
      }) : _c('div', {
        staticClass: "iconfont icon-images"
      })]), _vm._v(" "), _c('el-input', {
        attrs: {
          "placeholder": "名称"
        },
        model: {
          value: (sitem.name),
          callback: function($$v) {
            _vm.$set(sitem, "name", $$v)
          },
          expression: "sitem.name"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "bind-btn",
        class: {
          ' iconfont icon-link': !sitem.main_category_id && !sitem.category_id
        },
        on: {
          "click": function($event) {
            return _vm.showCategory(fidx, sidx)
          }
        }
      }, [_vm._v("  " + _vm._s(sitem.main_category_id ? '主类目：' : '') + _vm._s(sitem.category_id ? '商品分类：' : '') + _vm._s(sitem.category_name ? sitem.category_name : '绑定分类'))]), _vm._v(" "), _c('div', {
        staticClass: "control-bar move iconfont icon-stream"
      }), _vm._v(" "), _c('div', {
        staticClass: "control-bar remove iconfont icon-trash",
        on: {
          "click": function($event) {
            return _vm.remove(fidx, sidx)
          }
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "form-child"
      }, [_c('draggable', _vm._b({
        model: {
          value: (sitem.children),
          callback: function($$v) {
            _vm.$set(sitem, "children", $$v)
          },
          expression: "sitem.children"
        }
      }, 'draggable', _vm.dragLastOptions, false), _vm._l((sitem.children), function(litem, lidx) {
        return _c('div', {
          key: litem._uid || lidx,
          staticClass: "form-last"
        }, [_c('div', {
          staticClass: "form-item"
        }, [_c('div', {
          staticClass: "setting-img",
          on: {
            "click": function($event) {
              return _vm.showImgs(fidx, sidx, lidx)
            }
          }
        }, [(litem.img) ? _c('img', {
          attrs: {
            "src": litem.img ? litem.img : 'https://fakeimg.pl/50x50',
            "alt": ""
          }
        }) : _c('div', {
          staticClass: "iconfont icon-images"
        })]), _vm._v(" "), _c('el-input', {
          attrs: {
            "placeholder": "名称"
          },
          model: {
            value: (litem.name),
            callback: function($$v) {
              _vm.$set(litem, "name", $$v)
            },
            expression: "litem.name"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "bind-btn",
          class: {
            'iconfont icon-link': !litem.main_category_id && !litem.category_id
          },
          on: {
            "click": function($event) {
              return _vm.showCategory(fidx, sidx, lidx)
            }
          }
        }, [_vm._v(" " + _vm._s(litem.main_category_id ? '主类目：' : '') + _vm._s(litem.category_id ? '商品分类：' : '') + _vm._s(litem.category_name ? litem.category_name : '绑定分类'))]), _vm._v(" "), _c('div', {
          staticClass: "control-bar move iconfont icon-stream"
        }), _vm._v(" "), _c('div', {
          staticClass: "control-bar remove iconfont icon-trash",
          on: {
            "click": function($event) {
              return _vm.remove(fidx, sidx, lidx)
            }
          }
        })], 1)])
      }), 0), _vm._v(" "), _c('el-button', {
        staticClass: "child-add-btn iconfont icon-plus-circle",
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            return _vm.add(fidx, sidx)
          }
        }
      }, [_vm._v(" 添加三级分类")])], 1)])
    }), 0), _vm._v(" "), _c('el-button', {
      staticClass: "child-add-btn iconfont icon-plus-circle",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.add(fidx)
        }
      }
    }, [_vm._v(" 添加二级分类")])], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "parent-add-btn iconfont icon-plus",
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v(" 添加分类")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "content-padded-s section-white content-center"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "绑定分类",
      "visible": _vm.categoryDialog,
      "before-close": _vm.hideCategory
    },
    on: {
      "update:visible": function($event) {
        _vm.categoryDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-radio-group', {
    model: {
      value: (_vm.curCateType),
      callback: function($$v) {
        _vm.curCateType = $$v
      },
      expression: "curCateType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "goodsCate"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "mainCate"
    }
  }, [_vm._v("主类目")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择分类"
    }
  }, [(_vm.curCateType === 'goodsCate') ? _c('el-cascader', {
    attrs: {
      "placeholder": "选择商品分类",
      "options": _vm.category,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleCateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curCateType === 'mainCate') ? _c('el-cascader', {
    attrs: {
      "placeholder": "选择主类目",
      "options": _vm.mainCategory,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleMainCateChange
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.categoryDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setCategory
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择页面",
      "visible": _vm.pageDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.pageDialogVisible = $event
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selectedCustomPage),
      callback: function($$v) {
        _vm.selectedCustomPage = $$v
      },
      expression: "selectedCustomPage"
    }
  }, _vm._l((_vm.customPageList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.page_name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pageDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmPageDialog
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4993d180", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4993d180"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/category.vue
// module id = 2682
// module chunks = 0